import { ReactNode } from "react";
import { Field } from "../../types/GameTypes";
import { Box } from "../Box";
import "./HelpOverlay.css";
import { Overlay } from "./Overlay";

type HelpOverlayProps = {
  field: Field | undefined;
  onDismissed: () => void;
}

const titleFor = (field: Field) => {
  switch(field) {
    case "bodyStyle": return "Body"
    case "madeIn": return "Origin"
    case "manufacturer": return "Make"
    case "poweredBy": return "Power"
    case "model": return "Model"
  }
}

type HelpContent = {
  subText?: string;
  wrongSubText?: string;
  wrongDesc: string| ReactNode;
  closeDesc: string | ReactNode;
  rightDesc: string;
}
const contentFor = (field: Field):HelpContent => {
  switch(field) {
    case "bodyStyle": return {
      subText: "FAMILY",
      wrongSubText: "FAMILY",
      wrongDesc: "Not even the right body style FAMILY",
      closeDesc: <>Correct FAMILY; one of <ul><li>2 DOOR</li><li>4/5 DOOR</li><li>SUV</li></ul></>,
      rightDesc: "The correct body style",
     }
    case "madeIn": return {
      wrongSubText: 'CONT',
      subText: "CONT",
      wrongDesc: <>Wrong CONTinent; options: <ul><li>AMERicas</li><li>ASIA</li><li>EUROpe</li></ul></>,
      closeDesc: "Correct CONTinent, wrong country",
      rightDesc: "The correct country of origin",
     }
    case "manufacturer": return {
      wrongSubText: 'PARENT',
      subText: "PARENT",
      wrongDesc: "Not even the right PARENT group",
      closeDesc: "Correct PARENT corporation, wrong company",
      rightDesc: "The correct manufacturer",
     }
    case "poweredBy": return {
      wrongDesc: "Unrelated power source; e.g. ICE↔︎EV",
      closeDesc: <>Semi-related by energy source; e.g. <ul><li>ICE↔︎Hybrid</li><li>Hybrid↔︎EV</li></ul></>,
      rightDesc: "The correct power source",
     }
    case "model": return {
      wrongDesc: "Not even a single letter matches",
      closeDesc: "At least one letter matches",
      rightDesc: "The correct model name",
     }
  } 
}

export const HelpOverlay: React.FC<HelpOverlayProps> = ({field, onDismissed}: HelpOverlayProps) => {
  if (!field) return null;
  const title = titleFor(field);
  const {subText, wrongSubText, wrongDesc, closeDesc, rightDesc} = contentFor(field);
  return (
    <Overlay suffix="Help" dismissButtonText="Got It" onDismissed={onDismissed}>
      <h2>{title}</h2>
      <section className="HelpSection">
        <Box mode="Wrong" mainText="Wrong" subText={wrongSubText} field={field}/>
        <h5 className="desc">{wrongDesc}</h5>
      </section>
      <section className="HelpSection">
        <Box mode="Close" mainText="Close" subText={subText} field={field}/>
        <h5 className="desc">{closeDesc}</h5>
      </section>
      <section className="HelpSection">
        <Box mode="Right" mainText="Right" field={field}/>
        <h5 className="desc"  >{rightDesc}</h5>
      </section>
      <br/>

    </Overlay>
  )
}